type GenderTitle = 'mr' | 'mrs';

export const GENDER_TITLES: { [key in GenderTitle]: GenderTitle } = {
  mr: 'mr',
  mrs: 'mrs',
};
